import React from 'react';
import PropTypes from 'prop-types';
import { Message, Divider } from 'semantic-ui-react';

const FacebookEmbed = props => {
  let dimensions = {
    smallHeight: 450,
    height: 500,
    width: 500,
  };

  if (props.size === 'small') {
    dimensions = {
      smallHeight: 300,
      height: 320,
      width: 320,
    };
  }

  const style = {
    minHeight: 330,
    height: '100%',
    ...props.style,
  };

  return (
    <div>
      <iframe
        src={`https://www.facebook.com/plugins/post.php?href=${props.url}&height=${dimensions.smallHeight}`}
        width={dimensions.width}
        scrolling="true"
        frameBorder="0"
        allowTransparency="true"
        style={style}
      />
      <Divider />
      {
        props.type === 'VIDEO' &&
        <Message>
          <p>
           If you cannot see the video above it most likely cannot be embedded off Facebook,
           but you can still add it to the campaign for tracking
          </p>
        </Message>
      }

    </div>
  );
};

FacebookEmbed.propTypes = {
  url: PropTypes.string.isRequired,
  style: PropTypes.object,
  size: PropTypes.string,
  type: PropTypes.string,
};

FacebookEmbed.defaultProps = {
  style: {},
  size: 'medium',
  type: 'POST',
};

export default FacebookEmbed;



/** WEBPACK FOOTER **
 ** ./src/components/facebook-embed/index.js
 **/